export const RECOMMENDED = "recommended";
export const APPLIED = "applied";
export const SAVED = "saved";
export const DASHBOARD_TABS = [RECOMMENDED, APPLIED, SAVED];
